/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ActivityEventType,
  ActivityFeedResponse,
  EntityType,
  MarkEventReadResponse,
  MarkSeenRequest,
  MarkSeenResponse,
  NotificationsResponse,
  Problem,
  UserUnreadCountResponse,
} from '../models/index';
import {
    ActivityEventTypeFromJSON,
    ActivityEventTypeToJSON,
    ActivityFeedResponseFromJSON,
    ActivityFeedResponseToJSON,
    EntityTypeFromJSON,
    EntityTypeToJSON,
    MarkEventReadResponseFromJSON,
    MarkEventReadResponseToJSON,
    MarkSeenRequestFromJSON,
    MarkSeenRequestToJSON,
    MarkSeenResponseFromJSON,
    MarkSeenResponseToJSON,
    NotificationsResponseFromJSON,
    NotificationsResponseToJSON,
    ProblemFromJSON,
    ProblemToJSON,
    UserUnreadCountResponseFromJSON,
    UserUnreadCountResponseToJSON,
} from '../models/index';

export interface GetClaimActivityFeedRequest {
    claimId: number;
    lastSeenEventId?: number;
    limit?: number;
    type?: ActivityEventType;
}

export interface GetCompanyActivityFeedRequest {
    companyId: number;
    lastSeenEventId?: number;
    limit?: number;
    type?: ActivityEventType;
    entityType?: EntityType;
}

export interface GetUserNotificationsRequest {
    limit?: number;
}

export interface MarkActivitySeenRequest {
    markSeenRequest: MarkSeenRequest;
}

export interface MarkEventReadRequest {
    eventId: number;
}

/**
 * ActivitiesApi - interface
 * 
 * @export
 * @interface ActivitiesApiInterface
 */
export interface ActivitiesApiInterface {
    /**
     * Returns a cursor-based paginated activity feed for a specific claim. Use lastSeenEventId query parameter for pagination. 
     * @summary Get paginated activity feed for a claim
     * @param {number} claimId Claim ID
     * @param {number} [lastSeenEventId] Cursor for pagination - events with ID greater than this will be returned
     * @param {number} [limit] Maximum number of events to return
     * @param {ActivityEventType} [type] Filter by event type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesApiInterface
     */
    getClaimActivityFeedRaw(requestParameters: GetClaimActivityFeedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ActivityFeedResponse>>;

    /**
     * Returns a cursor-based paginated activity feed for a specific claim. Use lastSeenEventId query parameter for pagination. 
     * Get paginated activity feed for a claim
     */
    getClaimActivityFeed(requestParameters: GetClaimActivityFeedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ActivityFeedResponse>;

    /**
     * Returns a cursor-based paginated activity feed for a company. Use lastSeenEventId query parameter for pagination. 
     * @summary Get paginated activity feed for a company
     * @param {number} companyId Company ID
     * @param {number} [lastSeenEventId] Cursor for pagination - events with ID greater than this will be returned
     * @param {number} [limit] Maximum number of events to return
     * @param {ActivityEventType} [type] Filter by event type
     * @param {EntityType} [entityType] Filter by entity type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesApiInterface
     */
    getCompanyActivityFeedRaw(requestParameters: GetCompanyActivityFeedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ActivityFeedResponse>>;

    /**
     * Returns a cursor-based paginated activity feed for a company. Use lastSeenEventId query parameter for pagination. 
     * Get paginated activity feed for a company
     */
    getCompanyActivityFeed(requestParameters: GetCompanyActivityFeedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ActivityFeedResponse>;

    /**
     * Returns unread activity events (notifications) for the authenticated user. Events are filtered to those after the user\'s last seen event ID. 
     * @summary Get unread notifications for current user
     * @param {number} [limit] Maximum number of notifications to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesApiInterface
     */
    getUserNotificationsRaw(requestParameters: GetUserNotificationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NotificationsResponse>>;

    /**
     * Returns unread activity events (notifications) for the authenticated user. Events are filtered to those after the user\'s last seen event ID. 
     * Get unread notifications for current user
     */
    getUserNotifications(requestParameters: GetUserNotificationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NotificationsResponse>;

    /**
     * Returns the count of unread activity events for the authenticated user. 
     * @summary Get count of unread notifications for current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesApiInterface
     */
    getUserUnreadCountRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserUnreadCountResponse>>;

    /**
     * Returns the count of unread activity events for the authenticated user. 
     * Get count of unread notifications for current user
     */
    getUserUnreadCount(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserUnreadCountResponse>;

    /**
     * Updates the user\'s last seen event ID cursor. All events up to and  including the specified event ID will be considered \"seen\" by the user. 
     * @summary Mark activity events as seen
     * @param {MarkSeenRequest} markSeenRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesApiInterface
     */
    markActivitySeenRaw(requestParameters: MarkActivitySeenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MarkSeenResponse>>;

    /**
     * Updates the user\'s last seen event ID cursor. All events up to and  including the specified event ID will be considered \"seen\" by the user. 
     * Mark activity events as seen
     */
    markActivitySeen(requestParameters: MarkActivitySeenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MarkSeenResponse>;

    /**
     * Marks a specific activity event as read by setting its read_at timestamp. This is used for individual notification read tracking, separate from the cursor-based \"seen\" system. The cursor marks all events ≤ ID as seen, while read_at tracks individual notification interactions. 
     * @summary Mark individual notification as read
     * @param {number} eventId Activity event ID to mark as read
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesApiInterface
     */
    markEventReadRaw(requestParameters: MarkEventReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MarkEventReadResponse>>;

    /**
     * Marks a specific activity event as read by setting its read_at timestamp. This is used for individual notification read tracking, separate from the cursor-based \"seen\" system. The cursor marks all events ≤ ID as seen, while read_at tracks individual notification interactions. 
     * Mark individual notification as read
     */
    markEventRead(requestParameters: MarkEventReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MarkEventReadResponse>;

}

/**
 * 
 */
export class ActivitiesApi extends runtime.BaseAPI implements ActivitiesApiInterface {

    /**
     * Returns a cursor-based paginated activity feed for a specific claim. Use lastSeenEventId query parameter for pagination. 
     * Get paginated activity feed for a claim
     */
    async getClaimActivityFeedRaw(requestParameters: GetClaimActivityFeedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ActivityFeedResponse>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling getClaimActivityFeed().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['lastSeenEventId'] != null) {
            queryParameters['lastSeenEventId'] = requestParameters['lastSeenEventId'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/activity`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ActivityFeedResponseFromJSON(jsonValue));
    }

    /**
     * Returns a cursor-based paginated activity feed for a specific claim. Use lastSeenEventId query parameter for pagination. 
     * Get paginated activity feed for a claim
     */
    async getClaimActivityFeed(requestParameters: GetClaimActivityFeedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ActivityFeedResponse> {
        const response = await this.getClaimActivityFeedRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a cursor-based paginated activity feed for a company. Use lastSeenEventId query parameter for pagination. 
     * Get paginated activity feed for a company
     */
    async getCompanyActivityFeedRaw(requestParameters: GetCompanyActivityFeedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ActivityFeedResponse>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getCompanyActivityFeed().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['lastSeenEventId'] != null) {
            queryParameters['lastSeenEventId'] = requestParameters['lastSeenEventId'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        if (requestParameters['entityType'] != null) {
            queryParameters['entityType'] = requestParameters['entityType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/companies/{companyId}/activity`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ActivityFeedResponseFromJSON(jsonValue));
    }

    /**
     * Returns a cursor-based paginated activity feed for a company. Use lastSeenEventId query parameter for pagination. 
     * Get paginated activity feed for a company
     */
    async getCompanyActivityFeed(requestParameters: GetCompanyActivityFeedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ActivityFeedResponse> {
        const response = await this.getCompanyActivityFeedRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns unread activity events (notifications) for the authenticated user. Events are filtered to those after the user\'s last seen event ID. 
     * Get unread notifications for current user
     */
    async getUserNotificationsRaw(requestParameters: GetUserNotificationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NotificationsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/me/notifications`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NotificationsResponseFromJSON(jsonValue));
    }

    /**
     * Returns unread activity events (notifications) for the authenticated user. Events are filtered to those after the user\'s last seen event ID. 
     * Get unread notifications for current user
     */
    async getUserNotifications(requestParameters: GetUserNotificationsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NotificationsResponse> {
        const response = await this.getUserNotificationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the count of unread activity events for the authenticated user. 
     * Get count of unread notifications for current user
     */
    async getUserUnreadCountRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserUnreadCountResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/me/notifications/unread-count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserUnreadCountResponseFromJSON(jsonValue));
    }

    /**
     * Returns the count of unread activity events for the authenticated user. 
     * Get count of unread notifications for current user
     */
    async getUserUnreadCount(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserUnreadCountResponse> {
        const response = await this.getUserUnreadCountRaw(initOverrides);
        return await response.value();
    }

    /**
     * Updates the user\'s last seen event ID cursor. All events up to and  including the specified event ID will be considered \"seen\" by the user. 
     * Mark activity events as seen
     */
    async markActivitySeenRaw(requestParameters: MarkActivitySeenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MarkSeenResponse>> {
        if (requestParameters['markSeenRequest'] == null) {
            throw new runtime.RequiredError(
                'markSeenRequest',
                'Required parameter "markSeenRequest" was null or undefined when calling markActivitySeen().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/me/activity/seen`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MarkSeenRequestToJSON(requestParameters['markSeenRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MarkSeenResponseFromJSON(jsonValue));
    }

    /**
     * Updates the user\'s last seen event ID cursor. All events up to and  including the specified event ID will be considered \"seen\" by the user. 
     * Mark activity events as seen
     */
    async markActivitySeen(requestParameters: MarkActivitySeenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MarkSeenResponse> {
        const response = await this.markActivitySeenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Marks a specific activity event as read by setting its read_at timestamp. This is used for individual notification read tracking, separate from the cursor-based \"seen\" system. The cursor marks all events ≤ ID as seen, while read_at tracks individual notification interactions. 
     * Mark individual notification as read
     */
    async markEventReadRaw(requestParameters: MarkEventReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MarkEventReadResponse>> {
        if (requestParameters['eventId'] == null) {
            throw new runtime.RequiredError(
                'eventId',
                'Required parameter "eventId" was null or undefined when calling markEventRead().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/me/activity/{eventId}/read`.replace(`{${"eventId"}}`, encodeURIComponent(String(requestParameters['eventId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MarkEventReadResponseFromJSON(jsonValue));
    }

    /**
     * Marks a specific activity event as read by setting its read_at timestamp. This is used for individual notification read tracking, separate from the cursor-based \"seen\" system. The cursor marks all events ≤ ID as seen, while read_at tracks individual notification interactions. 
     * Mark individual notification as read
     */
    async markEventRead(requestParameters: MarkEventReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MarkEventReadResponse> {
        const response = await this.markEventReadRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
